var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "app" } }, [
    _vm.$route.path.indexOf("/customer/") >= 0
      ? _c(
          "div",
          [
            _vm.$route.path.indexOf("/customer/forgotpassword") != 0 &&
            _vm.$route.path.indexOf("/customer/resetpassword") != 0
              ? [_c("customer-header")]
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "app-sidebar-right", attrs: { id: "wrapper" } },
              [_c("router-view")],
              1
            )
          ],
          2
        )
      : _c(
          "div",
          [
            _vm.$route.path.indexOf("/qrcode/print") >= 0
              ? [_c("router-view")]
              : [
                  _c("app-header"),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "app-sidebar-right admin-dash-view",
                      attrs: { id: "wrapper" }
                    },
                    [_c("app-sidebar"), _vm._v(" "), _c("router-view")],
                    1
                  )
                ]
          ],
          2
        )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7ba5bd90", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7ba5bd90","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = null
// module chunks = 